import './App.css';
import { BrowserRouter as Router } from "react-router-dom";
import NavigationBar from './utils/NavigationBar';
import AnimatedRoutes from './components/AnimatedRoutes';

function App() {
  return (
    <div className="App">
      <Router>
        <NavigationBar />
        <AnimatedRoutes />
      </Router>
    </div>
  );
}

export default App;
